export enum DistributionType {

  RADIUS = 'radius',
  ADDRESS = 'address',
  LIST = 'list',
}
